module.exports = __webpack_public_path__ + "static/media/16UNODC7.fe16446f.jpg";